import { Storage } from 'core';

// 本地语言包
import zhCN from '../i18n/zh-CN';
import enUS from '../i18n/en-US';
import arEG from '../i18n/ar-EG';
import enAU from '../i18n/en-AU';
import esMX from '../i18n/es-MX';
import ptBR from '../i18n/pt-BR';
import ruRU from '../i18n/ru-RU';
import ukUA from '../i18n/uk-UA';
import es419 from '../i18n/es-419';
import esCO from '../i18n/es-CO';

export const langMap: { [key: string]: typeof enUS | typeof zhCN } = {
  'zh-CN': zhCN,
  'en-US': enUS,
  'ar-EG': arEG,
  'en-AU': enAU,
  'es-CO': esCO,
  'es-MX': esMX,
  'es-CL': es419,
  'es-CR': es419,
  'es-419': es419,
  'pt-BR': ptBR,
  'ru-RU': ruRU,
  'uk-UA': ukUA,
};

function formatTextMessage(text: string, values: any) {
  const strList = text.split(
    new RegExp(
      `(${Object.keys(values)
        .map((k) => '{{\\s*'.concat(k, '\\s*}}'))
        .join('|')})`,
      'g',
    ),
  );
  const nodes = strList.map((str) => {
    const value = values[str.slice(2, -2).replace(/(^\s+|\s+$)/g, '')];
    if (value) {
      return value;
    }
    return str;
  });
  return nodes.join('');
}

// { 'a': [{ 'b': { 'c': 3 } }] }
// get(object, 'a[0].b.c') // 3
function get(source: any, path: string) {
  // a[3].b -> a.3.b -> [a,3,b]
  const paths = path.replace(/\[(\d+)\]/g, '.$1').split('.');
  let result = source;
  paths.some((p) => {
    result = Object(result)[p];
    if (result === undefined) return true;
    return false;
  });
  return result;
}

export const I18N = {
  translate(key: string, defaultValue?: string, values?: any) {
    const l: any = langMap[Storage.getLang()] || langMap['es-MX'];
    const baseL: any = langMap['zh-CN'];
    const text = get(l, key) || defaultValue || get(baseL, key);
    if (values) {
      return formatTextMessage(text, values);
    }
    return text;
  },
};
